import styled from 'styled-components';
import { palette } from 'styled-tools';

import { FontSizes, fontWeight, FontWeights, minWidth, Text } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled.section`
	padding: 40px 0;
	background-color: ${palette('white')};
	text-align: center;

	${minWidth('tablet')} {
		padding: 80px 0;
	}
`;

export const Heading = styled(Text).attrs({
	color: 'blue3',
	size: FontSizes.xl,
	lineHeight: FontSizes.xl,
	weight: FontWeights.Regular,
	el: 'h2',
})`
	grid-column: 1 / 4;
	margin-top: 0;
	margin-bottom: 8px;

	${minWidth('tablet')} {
		font-size: 49.5px;
	}
`;

export const Subheading = styled(Text).attrs({
	lineHeight: FontSizes.xl,
	el: 'p',
	styleAs: 'h3',
})`
	margin-top: 0;
	margin-bottom: 40px;
	color: ${palette('gray8')};
	font-size: 20px;
	${fontWeight(FontWeights.Regular)};
	grid-column: 1 / 4;
	${minWidth('tablet')} {
		font-size: 31.5px;
	}
`;

export const Stats = styled.div`
	grid-column: 1 / 4;
	margin: 0;
	margin-bottom: 40px;
	text-align: center;
`;

export const StatsGrid = styled(GridWrapper)`
	margin: 0;
`;

export const Stat = styled.div`
	border-radius: 16px;
	box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.08);
	margin-bottom: 16px;
	padding: 16px 16px 24px;

	&:last-of-type {
		margin-bottom: 0;
	}

	${minWidth('tablet')} {
		margin-bottom: 0;
		padding: 16px 32px 24px;
	}
`;

export const StatHeading = styled(Text).attrs({
	size: FontSizes.lg,
	el: 'h3',
	styleAs: 'h4',
})`
	color: ${palette('blue3')};
	${fontWeight(FontWeights.Medium)};
	margin-top: 0;
	margin-bottom: 8px;
`;

export const StatNumber = styled(Text).attrs({
	color: 'gray8',
	size: FontSizes['2xl'],
	weight: FontWeights.Medium,
	noMargin: true,
	el: 'p',
})``;

export const StatDescription = styled.p`
	color: ${palette('gray8')};
`;

export const Disclaimer = styled.div`
	color: ${palette('gray6')};
	font-size: 13.5px;
	${fontWeight(FontWeights.Medium)};
	grid-column: 1 / 4;
	margin-bottom: 40px;
`;

export const ButtonWrapper = styled.div`
	grid-column: 1 / 4;
	margin: 0 auto;
	width: 100%;

	${minWidth('tablet')} {
		width: 50%;
	}

	${minWidth('desktop')} {
		grid-column: 2 / 3;
		width: 100%;
	}
`;
